var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ci-job-name-component"},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),_c('span',{staticClass:"ci-status-text"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }